import React from "react";
import {IoTConnectionStatus} from "../codegen/graphql";
import {Chip} from "@mui/joy";
import {CheckCircleFilledRounded, ErrorFilledRounded, WarningFilledRounded} from "@mui-symbols-material/w300";
import {TFunction} from "i18next";
import {getIotStatusChipColors, getIotStatusLabel, IotStatusLabelOptions} from "../config/iotConnectionStatusConfig";

export const connectionStatusChipFactory = (
    connectionStatus: IoTConnectionStatus | string | undefined,
    t: TFunction,
    options?: IotStatusLabelOptions,
): React.ReactNode => {
    if (!connectionStatus) {
        return null;
    }

    const colors = getIotStatusChipColors(connectionStatus);

    return (
        <Chip sx={{ backgroundColor: colors.bg, color: colors.text }}>
            {getIotStatusLabel(connectionStatus, t, options)}
        </Chip>
    );
}


export const statusIconFactory = (connectionStatus: IoTConnectionStatus | string | undefined, fontSize?: number): React.ReactNode => {
    if (!connectionStatus) {
        return null;
    }
    switch(connectionStatus) {
        case 'RUNNING':
            return <CheckCircleFilledRounded color={'success'} sx={{fontSize: fontSize}}/>
        case 'WARNING':
            return <WarningFilledRounded color={'warning'} sx={{fontSize: fontSize}}/>
        case 'ERROR':
            return <ErrorFilledRounded color={'error'} sx={{fontSize: fontSize}} />
        case 'OFF':
        case 'CURRENTLY_OFFLINE':
        case 'NEVER_CONNECTED':
        case 'DATA_BUFFERING':
            return <ErrorFilledRounded color={'disabled'} sx={{fontSize: fontSize}}/>
        default:
            return <ErrorFilledRounded color={'disabled'} sx={{fontSize: fontSize}}/>
    }
}
